// TODO: replace console.error with logger
let createInterface = () => console.error('initialize setupInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let openInterface = () => console.error('initialize openInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let onOpenInterface = () => console.error('initialize onOpenInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let sendInterface = () => console.error('initialize sendInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let onMessageInterface = () => console.error('initialize onMessageInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let onErrorInterface = () => console.error('initialize onErrorInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let closeInterface = () => console.error('initialize closeInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let onCloseInterface = () => console.error('initialize onCloseInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let isOfflineInterface = () => console.error('initialize isOfflineInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let reconnectTimeoutInterface = () => console.error('initialize getReconnectTimeout with bumpInterfaceInit first...'); // eslint-disable-line no-console
let reAuthInterface = () => console.error('initialize reAuthInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console
let checkSocketConnectionInterface = () =>
  console.error('initialize checkSocketConnectionInterface with bumpInterfaceInit first...'); // eslint-disable-line no-console

export const bumpInterfaceInit = ({
  open,
  create,
  onOpen,
  send,
  onMessage,
  onError,
  close,
  onClose,
  isOffline,
  reconnectTimeout,
  reAuth,
  checkSocketConnection,
}) => {
  createInterface = create || createInterface;
  openInterface = open || openInterface;
  onOpenInterface = onOpen || onOpenInterface;
  sendInterface = send || sendInterface;
  onMessageInterface = onMessage || onMessageInterface;
  onErrorInterface = onError || onErrorInterface;
  closeInterface = close || closeInterface;
  onCloseInterface = onClose || onCloseInterface;
  isOfflineInterface = isOffline || isOfflineInterface;
  reconnectTimeoutInterface = reconnectTimeout || reconnectTimeoutInterface;
  reAuthInterface = reAuth || reAuthInterface;
  checkSocketConnectionInterface = checkSocketConnection || checkSocketConnectionInterface;
};

export const create = () => createInterface?.();
export const open = (context) => openInterface?.(context);
export const onOpen = (event) => onOpenInterface?.(event);
export const send = (message) => sendInterface?.(message);
export const onMessage = (event) => onMessageInterface?.(event);
export const onError = (event) => onErrorInterface?.(event);
export const close = (code, context) => closeInterface?.(code, context);
export const onClose = (event) => onCloseInterface?.(event);
export const isOffline = () => isOfflineInterface?.();
export const reconnectTimeout = () => reconnectTimeoutInterface?.();
export const reAuth = () => reAuthInterface?.();
export const checkSocketConnection = () => checkSocketConnectionInterface?.();
